import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import useApi from "../utils/useApi";
import { useAuth } from "../context/AuthContext";

const Breadcrumbs = ({ folderDetails }) => {
  const { callApi } = useApi();
  const { "*": dynamicPath } = useParams(); // Get wildcard path from URL
  const pathSegments = dynamicPath ? dynamicPath.split("/") : [];
  const [folderNames, setFolderNames] = useState({}); // Store folder names
  const { user } = useAuth();
  console.log("user..", user?.user_role);
  let currentPath = "/folder-details"; // Root path

  // ✅ Fetch folder names for each segment
  const fetchFolderNames = async () => {
    let namesMap = { ...folderNames };
    const isClient = user?.user_role?.toLowerCase() === "client";
    console.log("isClient" , isClient);

    for (let segment of pathSegments) {
      if (!namesMap[segment]) {
        try {
          const endpoint = isClient
          ? `/client/get-directory-info/${segment}`
          : `/admin/directories/get-directory-info/${segment}`;
          //const response = await callApi({ endpoint: `/admin/directories/get-directory-info/${segment}` });
          const response = await callApi({ endpoint });
          if (response?.success) {
            namesMap[segment] = response.data.entity_name; // Store folder name
          } else {
            namesMap[segment] = "Unknown Folder"; // Fallback
          }
        } catch (error) {
          console.error("Error fetching folder name:", error);
          namesMap[segment] = "Unknown Folder"; // Fallback
        }
      }
    }
    setFolderNames({ ...namesMap }); // Update state
  };

  useEffect(() => {
    if (pathSegments.length > 0) {
      fetchFolderNames();
    }
  }, [dynamicPath]);

  return (
    <div className="outer_holder_global_head">
      {/* ✅ Main Parent Folder */}
      <Link to="/shared-folders">
        <div className="global_head_tag">
          <span>
            <i className="fa-solid fa-folder-open"></i>
          </span>
          Shared Folders
        </div>
      </Link>

      {/* ✅ Dynamic Breadcrumbs */}
      {pathSegments.map((segment, index) => {
        currentPath += `/${segment}`; // Build path dynamically
        const folderName = folderNames[segment] || "Loading..."; // Show folder name

        return (
          <div key={index} className="test_folder_rename">
            <span>
              <i className="fa-solid fa-arrow-right"></i>
            </span>
            {index === pathSegments.length - 1 ? (
              <span className="breadcrumb-active">{folderName}</span> // Non-clickable last item
            ) : (
              <Link to={currentPath}>{folderName}</Link> // Clickable for intermediate folders
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
